(() => {
  if (customElements.get('xulie-collection-links')) return;
  let quickViewHandle = '';
  let quickViewBridgeInstalled = false;
  const normalize = value => String(value || '').normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase();
  const splitTypes = value => String(value || '').split('||').map(type => type.trim()).filter(Boolean);
  class XulieCollectionLinks extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.events = new AbortController();
      this.network = new AbortController();
      this.pageSize = Number(this.dataset.pageSize) || 8;
      this.visibleCount = this.pageSize;
      this.state = { types: [], query: '', min: null, max: null, inStock: false, sort: 'featured' };
      this.generation = 0;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-open-quick-view-popup]');
        if (!button) return;
        quickViewHandle = button.dataset.productHandle;
        if (!quickViewBridgeInstalled && window.jQuery?.ajaxPrefilter) {
          window.jQuery.ajaxPrefilter(options => {
            if (!quickViewHandle || typeof options.url !== 'string') return;
            const url = new URL(options.url, location.origin);
            if (url.origin === location.origin && url.pathname.endsWith('/products/' + quickViewHandle) && url.searchParams.get('view') === 'ajax_quick_view') {
              url.searchParams.set('view', 'xulie-links-quick-view');
              options.url = url.pathname + url.search;
              quickViewHandle = '';
            }
          });
          quickViewBridgeInstalled = true;
        }
      }, { capture: true, signal: this.events.signal });
      this.category = this.querySelector('[data-xcl-all]');
      this.grid = this.querySelector('[data-xcl-grid]');
      this.more = this.querySelector('[data-xcl-more]');
      this.status = this.querySelector('[data-xcl-status]');
      this.template = this.querySelector('[data-xcl-card-template]');
      this.listen(this.querySelector('[data-xcl-types]'), 'click', event => {
        const chip = event.target.closest('[data-xcl-type]');
        if (!chip) return;
        this.category = chip;
        chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        this.state.types = splitTypes(chip.dataset.xclType);
        this.querySelectorAll('[data-xcl-type]').forEach(button => {
          const active = button === chip;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.update(true);
      });
      this.listen(this.querySelector('[data-xcl-search]'), 'input', event => {
        clearTimeout(this.searchTimer);
        this.state.query = event.target.value.trim();
        this.searchTimer = setTimeout(() => this.update(true), 220);
      });
      this.listen(this.querySelector('[data-xcl-sort]'), 'change', event => {
        this.state.sort = event.target.value;
        this.update(true);
      });
      this.listen(this.querySelector('[data-xcl-apply]'), 'click', () => {
        const min = this.querySelector('[data-xcl-min]').value;
        const max = this.querySelector('[data-xcl-max]').value;
        this.state.min = min === '' ? null : Math.max(0, Number(min));
        this.state.max = max === '' ? null : Math.max(0, Number(max));
        if (this.state.min !== null && this.state.max !== null && this.state.min > this.state.max) {
          [this.state.min, this.state.max] = [this.state.max, this.state.min];
          this.querySelector('[data-xcl-min]').value = this.state.min;
          this.querySelector('[data-xcl-max]').value = this.state.max;
        }
        this.state.inStock = this.querySelector('[data-xcl-stock]').checked;
        this.querySelector('[data-xcl-filter]').open = false;
        this.update(true);
      });
      this.listen(this.querySelector('[data-xcl-reset]'), 'click', () => {
        this.state = { types: [], query: '', min: null, max: null, inStock: false, sort: 'featured' };
        this.querySelector('[data-xcl-search]').value = '';
        this.querySelector('[data-xcl-min]').value = '';
        this.querySelector('[data-xcl-max]').value = '';
        this.querySelector('[data-xcl-stock]').checked = false;
        this.querySelector('[data-xcl-sort]').value = 'featured';
        this.category = this.querySelector('[data-xcl-all]');
        this.querySelectorAll('[data-xcl-type]').forEach(button => {
          const active = button.hasAttribute('data-xcl-all');
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.update(true);
      });
      this.listen(this.more, 'click', event => {
        if (this.allowNormalPagination) return;
        event.preventDefault();
        if (this.busy) return;
        this.visibleCount += this.pageSize;
        this.update(false);
      });
      this.listen(document, 'click', event => {
        const filter = this.querySelector('[data-xcl-filter]');
        if (filter && !filter.contains(event.target)) filter.open = false;
      });
      const promotion = this.querySelector('[data-xcl-promotion]');
      const dialog = this.querySelector('dialog');
      if (promotion && dialog) {
        this.listen(promotion, 'click', () => {
          const content = this.querySelector('[data-xcl-promotion-body]');
          if (!content.hasChildNodes()) {
            const fragment = this.querySelector('[data-xcl-promotion-content]').content.cloneNode(true);
            fragment.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });
            content.append(fragment);
          }
          content.querySelector('[data-xcl-offer-summary]').hidden = false;
          content.querySelector('[data-xcl-offer-full]').hidden = true;
          dialog.showModal();
          content.scrollTop = 0;
        });
        this.listen(dialog, 'click', event => {
          if (event.target.closest('[data-xcl-shop-offer]')) {
            dialog.close();
            this.querySelector('.xcl__catalog')?.scrollIntoView({ block: 'start', behavior: 'auto' });
          }
          if (event.target.closest('[data-xcl-full-offer]')) {
            const target = dialog.querySelector('[data-xcl-offer-article]');
            if (!target.hasChildNodes()) {
              const fragment = this.querySelector('[data-xcl-full-article]').content.cloneNode(true);
              fragment.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });
              target.append(fragment);
            }
            dialog.querySelector('[data-xcl-offer-summary]').hidden = true;
            dialog.querySelector('[data-xcl-offer-full]').hidden = false;
            dialog.querySelector('[data-xcl-promotion-body]').scrollTop = 0;
            dialog.querySelector('[data-xcl-offer-back]').focus();
          }
          if (event.target.closest('[data-xcl-offer-back]')) {
            dialog.querySelector('[data-xcl-offer-summary]').hidden = false;
            dialog.querySelector('[data-xcl-offer-full]').hidden = true;
            dialog.querySelector('[data-xcl-promotion-body]').scrollTop = 0;
            dialog.querySelector('[data-xcl-full-offer]').focus();
          }
        });
        this.listen(this.querySelector('[data-xcl-close]'), 'click', () => dialog.close());
        this.listen(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      }
      if (Number(this.dataset.currentPage) > 1) this.allowNormalPagination = true;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.network?.abort();
      clearTimeout(this.searchTimer);
      this.started = false;
      this.indexPromise = null;
    }
    listen(element, type, handler) { element?.addEventListener(type, handler, { signal: this.events.signal }); }
    async collectionIndex() {
      if (this.products) return this.products;
      if (this.indexPromise) return this.indexPromise;
      this.indexPromise = (async () => {
        const products = [];
        const seen = new Set();
        const url = new URL(location.href);
        Array.from(url.searchParams.keys()).forEach(key => {
          if (key.startsWith('filter.') || ['sort_by', 'section_id', 'sections', 'q', 'page'].includes(key)) url.searchParams.delete(key);
        });
        url.searchParams.set('view', 'xulie-links-data');
        let page = 1;
        let hasNext = true;
        while (hasNext) {
          if (page > 100) throw new Error('Collection exceeds the supported pagination range.');
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { credentials: 'same-origin', signal: this.network.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`Collection response ${response.status}`);
          const data = JSON.parse(await response.text());
          if (String(data.collection_id) !== this.dataset.collectionId || data.currency !== this.dataset.currency || !Array.isArray(data.products)) throw new Error('Collection context mismatch.');
          for (const product of data.products) {
            if (seen.has(product.id)) throw new Error('Collection pagination repeated products.');
            seen.add(product.id);
            products.push(product);
          }
          hasNext = data.has_next === true;
          if (hasNext && data.products.length === 0) throw new Error('Collection page was empty.');
          if (!hasNext && products.length !== data.total) throw new Error('Collection changed while loading. Please retry.');
          page += 1;
        }
        this.products = products;
        this.updateCategoryCounts();
        return products;
      })();
      try { return await this.indexPromise; }
      catch (error) { this.indexPromise = null; throw error; }
    }
    updateCategoryCounts() {
      const represented = new Set();
      this.querySelectorAll('[data-xcl-type]').forEach(button => {
        const types = splitTypes(button.dataset.xclType);
        types.forEach(type => represented.add(type));
        const count = this.products.filter(product => this.matchesCategory(product, button)).length;
        button.querySelector('[data-xcl-type-count]').textContent = String(count);
        button.hidden = count === 0 && !button.hasAttribute('data-xcl-all');
      });
      const nav = this.querySelector('[data-xcl-types]');
      if (this.dataset.autoTypes !== 'true') return;
      [...new Set(this.products.map(product => product.type).filter(Boolean))].forEach(type => {
        if (represented.has(type)) return;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'xcl__chip'; button.dataset.xclType = type; button.setAttribute('aria-pressed', 'false');
        const label = document.createElement('span'); label.textContent = type;
        const count = document.createElement('small'); count.dataset.xclTypeCount = ''; count.textContent = String(this.products.filter(product => product.type === type).length);
        button.append(label, count); nav.append(button);
      });
    }
    matchesCategory(product, button) {
      if (!button || button.hasAttribute('data-xcl-all')) return true;
      const types = splitTypes(button.dataset.xclType);
      const keywords = splitTypes(button.dataset.xclKeywords).map(normalize);
      const excludes = splitTypes(button.dataset.xclExcludes).map(normalize);
      const chosenIds = splitTypes(button.dataset.xclProductIds);
      const text = normalize(`${product.title} ${product.handle}`);
      if (excludes.some(term => text.includes(term))) return false;
      if (chosenIds.includes(String(product.id))) return true;
      if (!types.length && !keywords.length) return false;
      return (!types.length || types.includes(product.type)) && (!keywords.length || keywords.some(term => text.includes(term)));
    }
    filteredProducts() {
      const state = this.state;
      const query = normalize(state.query);
      const products = this.products.filter(product =>
        this.matchesCategory(product, this.category) &&
        (!query || normalize(`${product.title} ${product.type}`).includes(query)) &&
        (state.min === null || Number(product.price) >= Math.round(state.min * 100)) &&
        (state.max === null || Number(product.price) <= Math.round(state.max * 100)) &&
        (!state.inStock || product.available)
      );
      if (state.sort === 'price-ascending') products.sort((a, b) => Number(a.price) - Number(b.price));
      if (state.sort === 'price-descending') products.sort((a, b) => Number(b.price) - Number(a.price));
      if (state.sort === 'title-ascending') products.sort((a, b) => a.title.localeCompare(b.title));
      if (state.sort === 'created-descending') products.sort((a, b) => Number(b.published) - Number(a.published));
      return products;
    }
    productCard(product) {
      const fragment = this.template.content.cloneNode(true);
      const card = fragment.querySelector('article'); card.dataset.xclProduct = product.id;
      const links = card.querySelectorAll('a'); links.forEach(link => { link.href = product.url; });
      card.querySelector('.xcl__image-link').setAttribute('aria-label', product.title);
      const image = card.querySelector('img');
      if (product.image) { image.src = product.image; image.alt = product.title; }
      else image.remove();
      card.querySelector('.xcl__product-title').textContent = product.title;
      card.querySelector('.xcl__product-price').innerHTML = product.price_html;
      const quick = card.querySelector('[data-open-quick-view-popup]');
      quick.dataset.productId = product.id; quick.dataset.productHandle = product.handle;
      quick.setAttribute('aria-label', `${this.dataset.quickView}: ${product.title}`);
      const soldOut = card.querySelector('.xcl__sold-out'); soldOut.textContent = this.dataset.soldOut; soldOut.hidden = product.available;
      return fragment;
    }
    async update(reset) {
      if (reset) this.visibleCount = this.pageSize;
      const generation = ++this.generation;
      this.busy = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.more.setAttribute('aria-disabled', 'true');
      this.status.textContent = this.dataset.loading;
      try {
        await this.collectionIndex();
        if (generation !== this.generation || !this.isConnected) return;
        this.allowNormalPagination = false;
        const products = this.filteredProducts();
        const shown = products.slice(0, this.visibleCount);
        const fragment = document.createDocumentFragment();
        const existing = [...this.grid.querySelectorAll('[data-xcl-product]')];
        const appendOnly = !reset && existing.length <= shown.length && existing.every((card, index) => String(shown[index].id) === card.dataset.xclProduct);
        const nextProducts = appendOnly ? shown.slice(existing.length) : shown;
        nextProducts.forEach(product => fragment.append(this.productCard(product)));
        if (appendOnly) this.grid.append(fragment);
        else this.grid.replaceChildren(fragment);
        this.querySelector('[data-xcl-empty]').hidden = products.length !== 0;
        const itemsLabel = this.querySelector('[data-xcl-label-items]').textContent;
        const showingLabel = this.querySelector('[data-xcl-label-showing]').textContent;
        this.querySelector('[data-xcl-count]').textContent = `${products.length} ${itemsLabel}`;
        this.querySelector('[data-xcl-progress]').textContent = `${showingLabel} ${shown.length} / ${products.length}`;
        this.more.hidden = shown.length >= products.length;
        const descriptions = [];
        const activeType = this.querySelector('[data-xcl-type].is-active span');
        if (!this.category.hasAttribute('data-xcl-all') && activeType) descriptions.push(activeType.textContent);
        if (this.state.query) descriptions.push(`“${this.state.query}”`);
        if (this.state.min !== null || this.state.max !== null) descriptions.push(`${this.dataset.currency} ${this.state.min ?? '0'}–${this.state.max ?? '…'}`);
        if (this.state.inStock) descriptions.push(this.querySelector('.xcl__stock').textContent.trim());
        this.querySelector('[data-xcl-active]').hidden = descriptions.length === 0;
        this.querySelector('[data-xcl-summary]').textContent = descriptions.join(' · ');
        this.status.textContent = '';
      } catch (error) {
        if (error.name === 'AbortError' || generation !== this.generation) return;
        this.status.textContent = this.dataset.error;
        this.allowNormalPagination = true;
      } finally {
        if (generation === this.generation) {
          this.busy = false;
          this.grid.setAttribute('aria-busy', 'false');
          this.more.removeAttribute('aria-disabled');
        }
      }
    }
  }
  customElements.define('xulie-collection-links', XulieCollectionLinks);
})();
